import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const crmOptionService = {
  getAll,
  addValue,
}

export function getAll() {
  return apiHelper(API_URL).get('/crm/options')
}

export function addValue(group, label) {
  return apiHelper(API_URL).post(`/crm/options/${group}`, { label })
}
